import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { WorkspaceLocation } from 'honeygrid-types'

import { workspacesQueryKey } from '../workspaces/useWorkspaces'
import { locationsQueryKey } from './useLocations'

interface CreateLocationParams {
	location: google.maps.places.PlaceResult
}

export const useCreateLocation = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const { organization } = useStytchOrganization<false>()

	return useMutation({
		mutationFn: ({ location }: CreateLocationParams) =>
			authFetch(`workspaces/${organization?.organization_id}/locations`, {
				method: 'POST',
				body: location,
			}) as Promise<WorkspaceLocation>,
		onSuccess: () => {
			// Invalidate locations list for workspace
			queryClient.invalidateQueries({ queryKey: locationsQueryKey(organization?.organization_id) })
			// Invalidate workspaces (workspace might have updated location count)
			queryClient.invalidateQueries({ queryKey: workspacesQueryKey() })
		},
	})
}
